import { render } from "./LangSwitch.vue?vue&type=template&id=7ee6ade8&scoped=true"
import script from "./LangSwitch.vue?vue&type=script&lang=js"
export * from "./LangSwitch.vue?vue&type=script&lang=js"

import "./LangSwitch.vue?vue&type=style&index=0&id=7ee6ade8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee6ade8"]])

export default __exports__